<template>
  <input
    type="text"

    :value="value"

    v-ok:enter
    ref="main"

    @beforeinput="mask"
    @input="set"
  />
</template>

<script>
import utils from "@/utils"

export default {
	name:  "DVfieldId",
	props: {
		value:  {
			type:    String,
			default: false,
		}
	},

	data() {
		return {
		};
	},
	methods: {
		set( event ) {
			this.$emit( "input", this.$refs.main.value )
		},

    mask( e ) {
	    if ( e && ( "data" in e ) ) {
	      if ( !e.data || !utils.uriCharsValid( e.data ) ) {
          e.stopPropagation();
          e.preventDefault();

          return false;
        }
      }
    }
	}
};
</script>

<style scoped>
</style>